import {useState} from 'react';
import updateObjectField from 'helpers/updateObject';

const useForm = ({values: propsValues = {}} = {}) => {
    const [values, setValues] = useState(propsValues);

    const handleChangeValues = newValues => {
        const value = {};
        newValues.forEach(newValue => {
            value[newValue.name] = newValue.value;
        });
        setValues(value);
    };

    const handleChangeValue = (name, value) => {
        setValues(current => ({...updateObjectField(current, name, value)}));
    };

    const handleChangeField = ({target: {name, value}}) => {
        handleChangeValue(name, value);
    };

    const handleChangeNumberField = ({target: {name, value}}) => {
        if (!value.match(/^\d*$/gi)) return;
        handleChangeValue(name, Number.parseInt(value));
    };

    return {
        values,
        setValues,
        onChangeField: handleChangeField,
        onChangeValue: handleChangeValue,
        onChangeValues: handleChangeValues,
        onChangeNumberField: handleChangeNumberField,
    };
};

export {useForm};
